import http from './config/config'

const routePath = "status"

export default {
    async findAll(){
        return http.get(routePath)
    },   
    async delete(id){
        return http.delete(`${routePath}/${id}`)
    },
    async create(newParameter){
        return http.post(`${routePath}`, newParameter)
    },
    async update(newParameter, id){
        return http.patch(`${routePath}/${id}`, newParameter)
    },
}